import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 4v6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 18h20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BedDouble";
const BedDouble = memo(themed(Icon));
export {
  BedDouble
};
//# sourceMappingURL=bed-double.js.map
